import { ReactNode } from 'react'

interface CardGridProps {
	children: ReactNode
	columns?: 2 | 3 | 4 | '2-fixed'
	className?: string
}

export function CardGrid ({
	children,
	columns = 3,
	className = ''
}: CardGridProps) {
	const colsClass = {
		2: 'spaces:grid-cols-1 spaces:@sm:grid-cols-2',
		'2-fixed': 'spaces:grid-cols-2',
		3: 'spaces:grid-cols-1 spaces:@sm:grid-cols-2 spaces:@lg:grid-cols-3',
		4: 'spaces:grid-cols-1 spaces:@sm:grid-cols-2 spaces:@lg:grid-cols-3 spaces:@xl:grid-cols-4'
	}[columns]

	return (
		<div className={`spaces:@container ${className}`}>
			<div className={`spaces-card-grid spaces:grid ${colsClass} spaces:gap-12`}>{children}</div>
		</div>
	)
}
